
import draggable from "vuedraggable"

import { mdiPlus, mdiClose, mdiCancel, mdiCrop } from "@mdi/js"
import Modal from "@/components/base/modal/Modal"
import ImageUploader from "@/components/base/image/ImageUploader"
import Button from "@/components/base/Button"
import OPicture from "@/components/base/image/OPicture"
import UploadPreview from "@/components/base/image/UploadPreview"
import ImageDropzone from "@/components/base/input/dropzone/ImageDropzone"
import imageService from "@/services/image.service"
const REQUIRE_DELETE_CONFIRMATION = true

export default {
    name: "ImageGallery",
    components: {
        Button,
        Modal,
        draggable,
        ImageUploader,
        ImageDropzone,
        OPicture,
        UploadPreview,
    },
    props: {
        showNavButtons: {
            type: Boolean,
            default: true,
        },
        showGalleryImages: {
            type: Boolean,
            default: true,
        },
        showMainImages: {
            type: Boolean,
            default: true,
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
        givenBusiness: {
            type: Object,
            default: null,
        },
    },
    icons: {
        mdiPlus,
        mdiClose,
        mdiCancel,
        mdiCrop,
    },
    data: function () {
        return {
            numberOfMainImages: 5,
            maxNumberOfImages: 10,
            images: [],
            isDragging: false,
            inputId: "add_image",
            showModal: false,
            confirmDeleteIndex: null,
            editingImageIndex: null,
        }
    },
    computed: {
        mainImages() {
            return Array.isArray(this.givenBusiness.main_images)
                ? this.givenBusiness.main_images
                : []
        },
        galleryImages() {
            return Array.isArray(this.givenBusiness.gallery_images)
                ? this.givenBusiness.gallery_images
                : []
        },
        canUploadImages() {
            return (
                this.images.length < this.maxNumberOfImages && !this.isDragging
            )
        },
        showConfirmDeleteModal: {
            get() {
                return this.confirmDeleteIndex !== null
            },
            set() {
                this.confirmDeleteIndex = null
            },
        },
        editingImage: {
            get() {
                if (this.editingImageIndex == null) return
                return this.images[this.editingImageIndex]
            },
            set(newVal) {
                if (this.editingImageIndex !== null) {
                    this.images[this.editingImageIndex] = newVal
                } else {
                    this.images.push(newVal)
                }
                this.showModal = false
            },
        },
    },
    watch: {
        images(value) {
            if (value.length >= this.numberOfMainImages) {
                this.givenBusiness.main_images = value.slice(0, 5)
                this.givenBusiness.gallery_images = value.slice(5)
            } else {
                this.givenBusiness.main_images = value.slice()
                this.givenBusiness.gallery_images = []
            }
        },
    },
    created() {
        this.images.push(...this.mainImages)
        this.images.push(...this.galleryImages)
    },
    methods: {
        onDeleteBtnClick(index) {
            if (REQUIRE_DELETE_CONFIRMATION) {
                this.confirmDeleteIndex = index
            } else {
                this.$emit("edit")
                this.images.splice(index, 1)
            }
        },
        onEditImage(image) {
            this.editingImageIndex = this.images.indexOf(image)
            this.showModal = true
        },
        deleteImage(index) {
            this.$emit("edit")
            if (this.images[index]) this.images.splice(index, 1)
            this.confirmDeleteIndex = null
        },
        onDragStart(_, image) {
            let style = document.getElementById(image.id)?.style
            if (!style) return
            style.background = "transparent"
            style.border = "2px solid transparent"
            let styleBtn = document.getElementById("btn" + image.id).style
            styleBtn.display = "none"
            setTimeout(
                (function (style, styleBtn) {
                    return function () {
                        //Set style here
                        document.getElementById(image.id).style = style
                        document.getElementById("btn" + image.id).style =
                            styleBtn
                    }
                })(style, styleBtn),
                1
            )
        },
        onFilesDropped(files) {
            for (const file of files) {
                const image = imageService.asClass(file)
                image.create()
                this.images.push(image)
            }
        },
        async upload(image) {
            let uJob = imageService.uploadImage({
                image: image,
                description: image.description,
                copyright: image.copyright,
                public: !image.private,
            })
            uJob.request.then(() => {
                this.showModal = false
            })
            uJob.image = image
            this.images.push(uJob)
        },
        onImageUpload(image) {
            this.editingImageIndex = null
            this.showModal = false
            this.images.push(image)
        },
    },
}
